import {MenuComponent} from '@/_metronic/assets/ts/components'
import {DropdownSelect} from '@/_metronic/partials/content/dropdown-select/DropdownSelect'
import PropagateWrapper from '@/_metronic/partials/content/propagate/PropagateWrapper'
import {useEffect, useState} from 'react'
import {useFilterReportRevenueSharing} from '../../core/FilterReportRevenueSharingProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {initialFilter} from '../../core/_models'
import {FilterDropdownBrand} from './FilterDropdownBrand'
import {FilterDropdownCity} from './FilterDropdownCity'
import {FilterDropdownOutlet} from './FilterDropdownOutlet'
import {FilterDropdownRegion} from './FilterDropdownRegion'
import {FilterDropdownSubBrand} from './FilterDropdownSubBrand'

const optionsArea = [
  {value: 'WIB', label: 'WIB'},
  {value: 'WITA', label: 'WITA'},
  {value: 'WIT', label: 'WIT'},
]

const optionsMonth = [
  {value: '1', label: 'January'},
  {value: '2', label: 'February'},
  {value: '3', label: 'March'},
  {value: '4', label: 'April'},
  {value: '5', label: 'May'},
  {value: '6', label: 'June'},
  {value: '7', label: 'July'},
  {value: '8', label: 'August'},
  {value: '9', label: 'September'},
  {value: '10', label: 'October'},
  {value: '11', label: 'November'},
  {value: '12', label: 'December'},
]

const FilterReportRevenueSharingForm = ({closeModal}) => {
  const {updateFilterReportRevenueSharingFormValue, filterReportRevenueSharingFormValue} =
    useFilterReportRevenueSharing()
  const {updateState} = useQueryRequest()
  const [filterValue, setFilterValue] = useState(initialFilter)
  const [selectedArea, setSelectedArea] = useState<any>([])
  const [selectedMonth, setSelectedMonth] = useState<any>([])
  const [selectedOutlet, setSelectedOutlet] = useState<any>([])
  const [selectedRegion, setSelectedRegion] = useState<any>([])
  const [selectedCity, setSelectedCity] = useState<any>([])
  const [selectedBrand, setSelectedBrand] = useState<any>([])
  const [selectedSubBrand, setSelectedSubBrand] = useState<any>([])
  const [optionsYear, setOptionsYear] = useState<any>(null)
  const [selectedYear, setSelectedYear] = useState<any>(null)
  const currentDate = new Date()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  useEffect(() => {
    const currentYear = new Date().getFullYear()
    const years = Array.from({length: 5}, (_, index) => currentYear - 4 + index)

    if (filterReportRevenueSharingFormValue) {
      setSelectedArea(filterReportRevenueSharingFormValue.area)
      setSelectedMonth(filterReportRevenueSharingFormValue.month)
      setSelectedOutlet(filterReportRevenueSharingFormValue.outlet)
      setSelectedBrand(filterReportRevenueSharingFormValue.brand)
      setSelectedSubBrand(filterReportRevenueSharingFormValue.sub_brand)
      setSelectedYear(filterReportRevenueSharingFormValue.year)
      setSelectedRegion(filterReportRevenueSharingFormValue.region)
      setSelectedCity(filterReportRevenueSharingFormValue.city)

      let monthList: string[] = []
      if (filterReportRevenueSharingFormValue.month) {
        filterReportRevenueSharingFormValue.month.forEach((element) => {
          monthList.push(element.value)
        })
      }
      let areaList: string[] = []
      if (filterReportRevenueSharingFormValue.area) {
        filterReportRevenueSharingFormValue.area.forEach((element) => {
          areaList.push(element.value)
        })
      }
      let outletList: string[] = []
      if (filterReportRevenueSharingFormValue.outlet) {
        filterReportRevenueSharingFormValue.outlet.forEach((element) => {
          outletList.push(element.value)
        })
      }
      let brandList: string[] = []
      if (filterReportRevenueSharingFormValue.brand) {
        filterReportRevenueSharingFormValue.brand.forEach((element) => {
          brandList.push(element.value)
        })
      }
      let subBrandList: string[] = []
      if (filterReportRevenueSharingFormValue.sub_brand) {
        filterReportRevenueSharingFormValue.sub_brand.forEach((element) => {
          subBrandList.push(element.value)
        })
      }
      let regionList: string[] = []
      if (filterReportRevenueSharingFormValue.region) {
        filterReportRevenueSharingFormValue.region.forEach((element) => {
          regionList.push(element.value)
        })
      }
      let cityList: string[] = []
      if (filterReportRevenueSharingFormValue.city) {
        filterReportRevenueSharingFormValue.city.forEach((element) => {
          cityList.push(element.value)
        })
      }

      setFilterValue({
        ...filterValue,
        set_area: Boolean(filterReportRevenueSharingFormValue.area),
        area: areaList,
        set_outlet_id: Boolean(filterReportRevenueSharingFormValue.outlet),
        outlet_id: outletList,
        set_brand_id: Boolean(filterReportRevenueSharingFormValue.brand),
        brand_id: brandList,
        set_sub_brand_id: Boolean(filterReportRevenueSharingFormValue.sub_brand),
        sub_brand_id: subBrandList,
        set_region_id: Boolean(filterReportRevenueSharingFormValue.region),
        region_id: regionList,
        set_city_id: Boolean(filterReportRevenueSharingFormValue.city),
        city_id: cityList,
        set_month: Boolean(filterReportRevenueSharingFormValue.month),
        month: monthList,
        set_year: Boolean(filterReportRevenueSharingFormValue.year),
        year: filterReportRevenueSharingFormValue.year
          ? filterReportRevenueSharingFormValue.year.value.toString()
          : currentDate.getFullYear().toString(),
      })
    } else {
      setOptionsYear(years?.map((x) => ({label: x, value: x})))
      setSelectedYear({value: currentDate.getFullYear(), label: currentDate.getFullYear()})
      setFilterValue({
        ...filterValue,
        set_year: true,
        year: currentDate.getFullYear().toString(),
      })
      updateFilterReportRevenueSharingFormValue({
        ...filterReportRevenueSharingFormValue,
        year: {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
      })
    }
  }, [])

  const resetData = () => {
    setSelectedOutlet([])
    setSelectedYear({value: currentDate.getFullYear(), label: currentDate.getFullYear()})
    setSelectedArea([])
    setSelectedBrand([])
    setSelectedSubBrand([])
    setSelectedRegion([])
    setSelectedCity([])
    setSelectedMonth([])
    setFilterValue({
      ...filterValue,
      set_year: true,
      year: currentDate.getFullYear().toString(),
    })
    updateFilterReportRevenueSharingFormValue(null)
    updateFilterReportRevenueSharingFormValue({
      year: {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
    })
    updateState(initialFilter)
    closeModal()
  }

  const filterData = () => {
    updateState(filterValue)
    closeModal()
  }

  const onChangeSelected = (name: string) => (value) => {
    if (name === 'area') {
      setSelectedArea(value)

      let areaList: string[] = []
      if (value) {
        value.forEach((element) => {
          areaList.push(element.value)
        })
      }
      setFilterValue({
        ...filterValue,
        set_area: Boolean(areaList.length > 0),
        area: areaList,
      })
      updateFilterReportRevenueSharingFormValue({
        ...filterReportRevenueSharingFormValue,
        area: value,
      })
    } else if (name === 'month') {
      setSelectedMonth(value)

      let monthList: string[] = []
      if (value) {
        value.forEach((element) => {
          monthList.push(element.value)
        })
      }

      setFilterValue({
        ...filterValue,
        set_month: Boolean(monthList.length > 0),
        month: monthList,
      })
      updateFilterReportRevenueSharingFormValue({
        ...filterReportRevenueSharingFormValue,
        month: value,
      })
    } else if (name === 'year') {
      if (value) {
        setSelectedYear(value)
      } else {
        setSelectedYear({value: currentDate.getFullYear(), label: currentDate.getFullYear()})
      }
      setFilterValue({
        ...filterValue,
        set_year: true,
        year: value && value.value.toString(),
      })
      updateFilterReportRevenueSharingFormValue({
        ...filterReportRevenueSharingFormValue,
        year: value ? value : {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
      })
    }
  }

  return (
    <>
      <div className='px-7 py-5' data-kt-user-table-filter='form'>
        <PropagateWrapper>
          <div className='row'>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Brand:</label>
                <FilterDropdownBrand
                  currentValue={selectedBrand || null}
                  onValueChange={(value) => {
                    setSelectedBrand(value)
                    let brandList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        brandList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_brand_id: Boolean(brandList.length > 0),
                      brand_id: brandList,
                    })
                    updateFilterReportRevenueSharingFormValue({
                      ...filterReportRevenueSharingFormValue,
                      brand: selectedBrand,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Sub Brand:</label>
                <FilterDropdownSubBrand
                  currentValue={selectedSubBrand || null}
                  onValueChange={(value) => {
                    setSelectedSubBrand(value)
                    let subBrandList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        subBrandList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_sub_brand_id: Boolean(subBrandList.length > 0),
                      sub_brand_id: subBrandList,
                    })
                    updateFilterReportRevenueSharingFormValue({
                      ...filterReportRevenueSharingFormValue,
                      sub_brand: selectedSubBrand,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Region:</label>
                <FilterDropdownRegion
                  currentValue={selectedRegion || null}
                  onValueChange={(value) => {
                    setSelectedRegion(value)
                    let regionList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        regionList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_region_id: Boolean(regionList.length > 0),
                      region_id: regionList,
                    })
                    updateFilterReportRevenueSharingFormValue({
                      ...filterReportRevenueSharingFormValue,
                      region: selectedRegion,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>City:</label>
                <FilterDropdownCity
                  currentValue={selectedCity || null}
                  onValueChange={(value) => {
                    setSelectedCity(value)
                    let cityList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        cityList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_city_id: Boolean(cityList.length > 0),
                      city_id: cityList,
                    })
                    updateFilterReportRevenueSharingFormValue({
                      ...filterReportRevenueSharingFormValue,
                      city: selectedCity,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Area:</label>
                <DropdownSelect
                  options={optionsArea}
                  value={selectedArea}
                  onChange={onChangeSelected('area')}
                  placeholder='All Area'
                  isMulti
                  isClearable
                />
              </div>
            </div>

            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Outlet:</label>
                <FilterDropdownOutlet
                  placeholder='All Outlet'
                  currentValue={selectedOutlet || null}
                  onValueChange={(value) => {
                    setSelectedOutlet(value)
                    let outletList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        outletList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_outlet_id: Boolean(outletList.length > 0),
                      outlet_id: outletList,
                    })
                    updateFilterReportRevenueSharingFormValue({
                      ...filterReportRevenueSharingFormValue,
                      outlet: selectedOutlet,
                    })
                  }}
                  isDisabled={false}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Month:</label>
                <DropdownSelect
                  options={optionsMonth}
                  isMulti
                  isClearable
                  value={selectedMonth}
                  onChange={onChangeSelected('month')}
                  placeholder='All Month'
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Year:</label>
                <DropdownSelect
                  options={optionsYear}
                  placeholder='Select Year'
                  value={selectedYear}
                  onChange={onChangeSelected('year')}
                />
              </div>
            </div>
          </div>
        </PropagateWrapper>
        <div className='d-flex justify-content-end'>
          <button
            type='button'
            // disabled={isLoading}
            onClick={resetData}
            className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='reset'
          >
            Reset
          </button>
          <button
            // disabled={isLoading}
            type='button'
            onClick={filterData}
            className='btn btn-primary fw-bold px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='filter'
          >
            Apply
          </button>
        </div>
      </div>
    </>
  )
}

export {FilterReportRevenueSharingForm}
